<template lang="pug">
div(style="width: 100%" v-if="!isFetchingBriqState")
  div(v-if="error")
    h1 Something went wrong!
  div(v-else-if="canView")
    .top-row.mb-S
      .filters
        slot(name="filters")
      BriqButton(@click="$emit('new')" v-if="canAddNew" data-test-id="new-inventory-item") New {{ name }}
    slot(name="overview")
  div(v-else)
    h1 Not enough permissions
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'InventoryTab',
  props: {
    error: Boolean,
    canAddNew: Boolean,
    canView: Boolean,
    name: String,
  },
  computed: {
    ...mapGetters('briqState', ['isFetchingBriqState']),
  },
}
</script>

<style scoped lang="stylus">
.top-row
  display flex
  justify-content space-between

.filters
  display flex
  align-items flex-end
</style>
